import { styled } from 'styled-components';

import { bodyMicroText, colors, transition } from '#/theme/theme';

export const RsvpButtonMenuItem = styled.span`
  color: ${colors.lightContentGrey};
  padding: 5px 10px;
  ${bodyMicroText};
  transition: ${transition};
  user-select: none;
  width: 100%;
  display: flex;
  cursor: pointer;

  &:hover {
    text-decoration: none;
    background: ${colors.calloutGrey};
  }
`;
